import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion"; // Import AnimatePresence separately

function About() {
  const [animatedText, setAnimatedText] = useState("Financial Growth");
  const [textIndex, setTextIndex] = useState(0);
  const animatedTexts = [
    "Financial Growth",
    "Banking Solutions",
    "Empowering Communities",
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTextIndex((prevIndex) => (prevIndex + 1) % animatedTexts.length);
    }, 3000); // Change text every 3 seconds

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    let timeoutId;

    const animateText = async () => {
      // Set the current text for typing animation
      setAnimatedText(animatedTexts[textIndex]);
    };

    animateText();

    return () => clearTimeout(timeoutId);
  }, [textIndex]);

  return (
    <section id="about" className="py-20 md:py-28 bg-gray-50 px-4 md:px-8">
      <div className="container mx-auto text-center">
        <motion.h2
          className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 leading-tight"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          Your Trusted Partner <br className="hidden md:block" /> in{" "}
          <span className="text-blue-600">
            {/* Typing Animation */}
            <AnimatePresence mode="wait">
              <motion.span
                key={animatedText}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
              >
                {animatedText}
              </motion.span>
            </AnimatePresence>
          </span>
        </motion.h2>
        <motion.p
          className="text-lg md:text-xl text-gray-600 mb-10 md:mb-12 leading-relaxed max-w-3xl mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6, ease: "easeOut" }}
        >
          Keziah Global Private Limited is revolutionizing financial inclusion in
          India. As a Business Correspondent of Fino Payments Bank, we extend
          essential banking and financial services to underserved communities,
          fostering economic empowerment and bridging the financial gap.
        </motion.p>
        <Link
          to="/about-us"
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-8 rounded-full text-lg md:text-xl transition duration-300 ease-in-out shadow-md hover:shadow-lg"
        >
          Learn More About Us
        </Link>
      </div>
    </section>
  );
}

export default About;